<pagination
  (pageChanged)="pageChanged.emit($event)"
  class="pagination-sm"
  [boundaryLinks]="true"
  [totalItems]="totalCount"
  [maxSize]="maxSize"
  [(ngModel)]="page"
  [itemsPerPage]="perPage"
  previousText="&lsaquo;"
  nextText="&rsaquo;"
  firstText="&laquo;"
  lastText="&raquo;"
></pagination>